import React, { useEffect, useRef, useState } from 'react';
import './PageLoader.css';

const PageLoader = ({ onFinish }) => {
  const videoRef = useRef(null);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    // Prevent scrolling while loader is active
    document.body.style.overflow = 'hidden';

    // Safety timeout — hide loader after 9 seconds even if video doesn't end
    const safetyTimer = setTimeout(() => {
      handleFinish();
    }, 9000);

    return () => {
      clearTimeout(safetyTimer);
      document.body.style.overflow = '';
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFinish = () => {
    if (fadeOut) return; // prevent double trigger
    setFadeOut(true);
    // Wait for the fade-out animation to complete before calling onFinish
    setTimeout(() => {
      document.body.style.overflow = '';
      onFinish();
    }, 600);
  };

  const handleVideoEnd = () => {
    handleFinish();
  };

  return (
    <div className={`page-loader ${fadeOut ? 'page-loader--fade-out' : ''}`}>
      {/* Subtle animated background particles */}
      <div className="page-loader__bg-glow page-loader__bg-glow--1"></div>
      <div className="page-loader__bg-glow page-loader__bg-glow--2"></div>
      <div className="page-loader__bg-glow page-loader__bg-glow--3"></div>

      <div className="page-loader__content">
        <div className="page-loader__video-wrapper">
          <video
            ref={videoRef}
            className="page-loader__video"
            src={`${process.env.PUBLIC_URL}/Green Gusto Logo Animation.mp4`}
            autoPlay
            muted
            playsInline
            onEnded={handleVideoEnd}
          />
        </div>
      </div>
    </div>
  );
};

export default PageLoader;
